import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/home_icon.svg'
import _imports_1 from '@/assets/img/plans_icon.svg'
import _imports_2 from '@/assets/img/settings_icon.svg'
import _imports_3 from '@/assets/img/admin_icon.svg'


const _hoisted_1 = { class: "navbar-container h-100 d-flex flex-column bg-transparent" }
const _hoisted_2 = { class: "navbar-layout flex-row flex-xl-column" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "small text-muted" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "small text-muted" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "small text-muted" }
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = { class: "small text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_feature = _resolveComponent("feature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "nav-link d-flex flex-column align-items-center justify-content-center",
          to: "/home"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-container rounded-2 p-2 mb-1" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Home Icon",
                width: "25",
                height: "24"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('menu.home')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_feature, { name: "plans" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "nav-link d-flex flex-column align-items-center justify-content-center",
              to: "/plans"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon-container rounded-2 p-2 mb-1" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Plans Icon",
                    width: "24",
                    height: "24"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('menu.plans')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "nav-link d-flex flex-column align-items-center justify-content-center",
          to: "/settings"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-container rounded-2 p-2 mb-1" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Settings Icon",
                width: "24",
                height: "24"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('menu.settings')), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.authStore.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link d-flex flex-column align-items-center justify-content-center",
              to: "/admin"
            }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon-container rounded-2 p-2 mb-1" }, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "Admin Icon",
                    width: "24",
                    height: "24"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('menu.admin')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}